const LIBRA_DASHBOARD_CONSTANTS = {
  // Accounts
  GET_ACCOUNTS: 'GET_ACCOUNTS',
  GET_ACCOUNTS_SUCCESS: 'GET_ACCOUNTS_SUCCESS',
  GET_ACCOUNTS_FAILURE: 'GET_ACCOUNTS_FAILURE',
  CREATE_ACCOUNT: 'CREATE_ACCOUNT',
  CREATE_ACCOUNT_SUCCESS: 'CREATE_ACCOUNT_SUCCESS',
  CREATE_ACCOUNT_FAILURE: 'CREATE_ACCOUNT_FAILURE',

  // Transfers
  GET_TRANSFERS: 'GET_TRANSFERS',
  GET_TRANSFERS_SUCCESS: 'GET_TRANSFERS_SUCCESS',
  GET_TRANSFERS_FAILURE: 'GET_TRANSFERS_FAILURE',
  CREATE_TRANSFER: 'CREATE_TRANSFER',
  CREATE_TRANSFER_SUCCESS: 'CREATE_TRANSFER_SUCCESS',
  CREATE_TRANSFER_FAILURE: 'CREATE_TRANSFER_FAILURE',
  PROCESS_TRANSFER: 'PROCESS_TRANSFER',
  PROCESS_TRANSFER_SUCCESS: 'PROCESS_TRANSFER_SUCCESS',
  PROCESS_TRANSFER_FAILURE: 'PROCESS_TRANSFER_FAILURE',

  // Corporate Beneficiaries
  GET_CORPORATE_BENEFICIARIES: 'GET_CORPORATE_BENEFICIARIES',
  GET_CORPORATE_BENEFICIARIES_SUCCESS: 'GET_CORPORATE_BENEFICIARIES_SUCCESS',
  GET_CORPORATE_BENEFICIARIES_FAILURE: 'GET_CORPORATE_BENEFICIARIES_FAILURE',
  CREATE_CORPORATE_BENEFICIARY: 'CREATE_CORPORATE_BENEFICIARY',
  CREATE_CORPORATE_BENEFICIARY_SUCCESS: 'CREATE_CORPORATE_BENEFICIARY_SUCCESS',
  CREATE_CORPORATE_BENEFICIARY_FAILURE: 'CREATE_CORPORATE_BENEFICIARY_FAILURE',

  // Scheduled Transfers
  GET_SCHEDULED_TRANSFERS: 'GET_SCHEDULED_TRANSFERS',
  GET_SCHEDULED_TRANSFERS_SUCCESS: 'GET_SCHEDULED_TRANSFERS_SUCCESS',
  GET_SCHEDULED_TRANSFERS_FAILURE: 'GET_SCHEDULED_TRANSFERS_FAILURE',
  CREATE_SCHEDULED_TRANSFER: 'CREATE_SCHEDULED_TRANSFER',
  CREATE_SCHEDULED_TRANSFER_SUCCESS: 'CREATE_SCHEDULED_TRANSFER_SUCCESS',
  CREATE_SCHEDULED_TRANSFER_FAILURE: 'CREATE_SCHEDULED_TRANSFER_FAILURE',
  UPDATE_SCHEDULED_TRANSFER: 'UPDATE_SCHEDULED_TRANSFER',
  UPDATE_SCHEDULED_TRANSFER_SUCCESS: 'UPDATE_SCHEDULED_TRANSFER_SUCCESS',
  UPDATE_SCHEDULED_TRANSFER_FAILURE: 'UPDATE_SCHEDULED_TRANSFER_FAILURE',

  // Libra Dashboard Configs
  GET_LIBRA_DASHBOARD_CONFIGS: 'GET_LIBRA_DASHBOARD_CONFIGS',
  GET_LIBRA_DASHBOARD_CONFIGS_SUCCESS: 'GET_LIBRA_DASHBOARD_CONFIGS_SUCCESS',
  GET_LIBRA_DASHBOARD_CONFIGS_FAILURE: 'GET_LIBRA_DASHBOARD_CONFIGS_FAILURE',

  // UI State
  SET_SELECTED_ACCOUNT: 'SET_SELECTED_ACCOUNT',
  SET_SELECTED_TRANSACTION: 'SET_SELECTED_TRANSACTION',
  SET_SELECTED_SWEEPOUT: 'SET_SELECTED_SWEEPOUT',
  SET_SELECTED_TRANSFER: 'SET_SELECTED_TRANSFER',
  SET_SELECTED_CLIENT: 'SET_SELECTED_CLIENT',
  SET_SELECTED_LIABILITY: 'SET_SELECTED_LIABILITY',
  SET_SELECTED_CORPORATE_BENEFICIARY: 'SET_SELECTED_CORPORATE_BENEFICIARY',
  SET_SELECTED_SCHEDULED_TRANSFER: 'SET_SELECTED_SCHEDULED_TRANSFER',
  CLEAR_LIBRA_STATE: 'CLEAR_LIBRA_STATE'
};

export default LIBRA_DASHBOARD_CONSTANTS;
